import { l as i } from "./index62.mjs";
import { useRef as u, useEffect as a } from "react";
function p(c, e) {
  const r = u(!0), t = u(e);
  a(() => {
    const n = t.current.every((o, f) => i.isEqual(o, e[f]));
    let s;
    return (r.current || !n) && (s = c()), r.current = !1, t.current = e, s;
  }, e);
}
export {
  p as useDeepEffect
};
